import classNames from 'classnames'
import React, { useContext, useEffect, useState } from 'react'
import topnetLogo from '../../assets/topnetLogo.svg'
import sonedeLogo from '../../assets/sonedeLogo.svg'
import stegLogo from '../../assets/stegLogo.svg'
import RadioFocus from '../../assets/radioFocus.svg'
import RadioON from '../../assets/radioON.svg'
import { Spinner } from 'utils/loading'
import ModalTestStatusUser from 'components/modalTestStatusUser'
import UserContext from 'contexts/UserContext'
import { useNavigate } from 'react-router-dom'
import CarteFact from './carteFact'
import paimentFactureContext from 'contexts/paimentFactureContext'

 
interface Props {

  onBackChangeStep: any
  onChangeStep: any
  setMontantDinar: (value: string) => void
  setMontantEuro: (value: string) => void
  MontantEuro:string
  canPay:boolean
  maxAmountPerInvoice:number
  facture: any
  // billerCode: any
  // setBillerCode: (value: string) => void
  idFacture: any
  setIdFacture: (value: string) => void
  // failedPaiementFacture: boolean
  // legnth: any
  functionTracks: any
  // handleConfirmPayment?: any
  paiementFacture: any
  loading: boolean
}

const FacturePaid: React.FC<Props> = ({
  // isTopnet,
  // isSoned,
  // isSteg,
  // onChangeVal,
  onBackChangeStep,
  onChangeStep,
  setMontantDinar,
  setMontantEuro,
  MontantEuro,
  canPay,
  maxAmountPerInvoice,
  facture,
  // billerCode,
  // setBillerCode,
  idFacture,
  setIdFacture,
  // failedPaiementFacture,
  // legnth,
  functionTracks,
  // handleConfirmPayment,
  paiementFacture,
  loading,
}) => {
  const { user } = useContext(UserContext)

  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent
  const navigate = useNavigate()
  const [ON, setON] = useState(false)
  const [val, setVal] = useState<any>()
  const [indexRecharge, setIndexRecharge] = useState(-1)
  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)
  const { paimentFacture, setPaimentFacture } = useContext(paimentFactureContext)

  const openModalStatus = () => {
    setOpenIsModalStatus(true)
  }
  const closeModalStatus = () => {
    setOpenIsModalStatus(false)
  } 
  return (
    <div>
      <div className="justify-center gap-5 w-full sm:overflow-y-auto no-scrollbar sm:max-h-[340px] flex flex-wrap  sm:gap-2 sm:mt-8">
     
        {loading ? (
          <div className="mt-5 ">
            <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />
          </div>
        ) : facture && facture?.length > 0 ? (
          <>

            {facture?.map((item: any, index: number) => (
              <div key={index}
                onClick={() => {
                  setMontantDinar(item?.AmountTND)
                  setMontantEuro(item?.amountToPay)
                  // setBillerCode(item?.billerCode)
                  setIdFacture(item?.id)
                  setVal(indexRecharge !== index ? setIndexRecharge(index) : setIndexRecharge(-1))
                  setPaimentFacture({...paimentFacture, amountTND: item.AmountTND, amountToPay: item.amountToPay })
                      setON(true)
                }}
              >
             
                    <CarteFact
                      logo={paimentFacture?.logoOperateur}
                      montanPayer={item?.amountToPay}
                      montantEnvoyer={item?.AmountTND}
                      On={ON}
                      index={index}
                      indexRecharge={indexRecharge}
                    />
                   
              </div>
            ))}
          </>
        ) 
        :
         (
          
            <div className="  my-10 px-10  border-2 border-dashed border-[#5754E5] text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3">
              Vous n’avez pas de facture à payer
            </div>
     
        )
        }
      </div>
      <div className={`flex gap-[16px] justify-center sm:justify-normal my-5 place-self-center sm:w-full`}>
        <button
          className={classNames(
            'text-[18px] text-[#556987] p-2 h-[56px] w-[180px] border border-[#556987] font-sans rounded-xl',
          )}
          onClick={onBackChangeStep}
        >
          Précédent
        </button>
        <button
          className={classNames(
            'text-[18px] text-[#FFF] w-[357px] p-2 h-[56px] rounded-xl  sm:w-full bg-[#4743C9]',
            indexRecharge === -1 || idFacture === '' ? 'bg-gray-400' : 'bg-[#4743C9] ',
          )}
          onClick={() => {
            if (statusComplete || 
              (statusNotFound 
                && maxAmountPerInvoice >= parseFloat(MontantEuro)
                && canPay
               )
            ) {
              paiementFacture()
              onChangeStep()
              functionTracks('2')
            } else if (statusPending) {
              
              openModalStatus()
            } else if (statusNotFound) {
              navigate('/personalinformation')

            }
          }}
          disabled={indexRecharge === -1 || idFacture === ''}
        >
          Suivant
        </button>
      </div>
      <ModalTestStatusUser
        isOpen={openIsModalStatus}
        closeModal={closeModalStatus}
        statusPending={statusPending}
        statusNotFound={statusNotFound}
      />
    </div>
  )
}

export default FacturePaid
